module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_9-639ce68e8f956fe954952e118715dfa8.svg";